import {useMemo} from "react";
import {minPartialPaymentInCents} from "../constants/defaultValues";
import {isUndefined} from "lodash";
import {env} from "@bounce/shared/constants";

const useIsValidAmount = (amount: number | undefined, planBalance: number | undefined): boolean => {
  return useMemo(() => {
    if (["staging"].includes(env)) {
      return true; // in staging, we bypass the validation for testing purposes
    }
    if (planBalance && !isUndefined(amount)) {
      if (planBalance >= minPartialPaymentInCents) {
        return amount >= minPartialPaymentInCents && amount <= planBalance;
      }
      return amount > 0 && amount <= planBalance;
    }

    return !!planBalance;
  }, [amount, planBalance]);
};

export default useIsValidAmount;
